import { alpha, Button, Stack } from '@mui/material';
import { colors } from '@themes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Date Picker buttons.
 *
 * @author Mikhail Siutsou
 * @function DayPickerButtons
 * @category components
 * @param {DayPickerButtonsProps} params day picker buttons params.
 * @return {JSX.Element} DatePicker buttons.
 */
var DayPickerButtons = function DayPickerButtons(_ref) {
  var acceptButton = _ref.acceptButton,
      cancelButton = _ref.cancelButton,
      numberOfMonths = _ref.numberOfMonths,
      handleClose = _ref.handleClose,
      handleChangeDate = _ref.handleChangeDate;
  return /*#__PURE__*/_jsxs(Stack, {
    direction: "row",
    spacing: 1.25,
    alignItems: "center",
    justifyContent: "flex-end",
    children: [/*#__PURE__*/_jsx(Button, {
      variant: "text",
      sx: {
        color: "".concat(colors.secondarySilver, " !important"),
        '&:hover': {
          color: "".concat(alpha(colors.secondarySilver, 0.8), " !important"),
          backgroundColor: 'transparent'
        }
      },
      size: "medium",
      onClick: handleClose,
      children: cancelButton
    }), /*#__PURE__*/_jsx(Button, {
      sx: {
        color: "".concat(colors.internationalOrange, " !important"),
        '&:hover': {
          color: "".concat(alpha(colors.internationalOrange, 0.8), " !important"),
          backgroundColor: 'transparent'
        }
      },
      variant: "text",
      size: "medium",
      onClick: handleChangeDate,
      children: acceptButton
    })]
  });
};

export { DayPickerButtons };